import gql from "graphql-tag";

export const mutationAuthorizationImages = gql`
  mutation authorizationImages(
    $projectId: ID!
    $authorization: String!
    $creditsForImages: String!
    $authorizationByClient: String!
    $authorizationFile: String!
  ) {
    projectImageAuthorization(
      projectId: $projectId
      authorization: $authorization
      creditsForImages: $creditsForImages
      authorizationByClient: $authorizationByClient
      authorizationFile: $authorizationFile
    ) {
      project {
        id
        title
      }
    }
}
`;

export const uploadImages = gql`
  mutation uploadFile($file: Upload!) {
    uploadPermissionFileProjects(file: $file) { 
      path
    }
  }
`;